<template>
    <router-view @contextmenu.prevent />
</template>

<script setup>
import { provide, onMounted, onUnmounted, ref, watch } from "vue"
import { decrypt } from '@/utils/cryptoAES.js';
import {WS_URL} from '@/utils/config.js'
import { initAutofit, destroyAutofit } from '@/utils/autofit.js'
let socket
let socket1
let flag = 'close'
let flag1 = 'close'
let sto
let sto1
const init = () => {
    // socket = new WebSocket('ws://xf.lcjaxf.cn:51800/webSocket')
    socket = new WebSocket(WS_URL+'webSocket')
    socket.onopen = () => {
        if (flag === 'padding') {
            location.reload()
        }
        flag = 'success'
        console.log('websocket success');
    }
    socket.onmessage = (event) => {
        console.log(event.data,event,'event');
    }
    socket.onclose = () => {
        console.log('websocket close');
        flag = 'padding'
        if (flag === 'padding') {
            socket.close()
            sto = setTimeout(() => {
                init()
            }, 2000)
        }
        else {
            location.reload()
            return clearTimeout(sto)
        }
    }
    provide('socket', socket)
}
// const itemsId = JSON.parse(decrypt((window.localStorage.getItem('userInfo')))).itemsId
// const userId = JSON.parse(decrypt((window.localStorage.getItem('userInfo')))).id

const init1 = () => {
    const userInfo = window.localStorage.getItem('userInfo')
    const parsedUserInfo = userInfo ? JSON.parse(decrypt(userInfo)) : null
    const itemsId = parsedUserInfo ? parsedUserInfo.itemsId : null
    const userId = parsedUserInfo ? parsedUserInfo.id : null
    // socket1 = new WebSocket(`ws://xf.lcjaxf.cn:51800/webSocket/${userId}/${itemsId}`)
    socket1 = new WebSocket(WS_URL+`webSocket/${userId}/${itemsId}`)
    socket1.onopen = () => {
        if (flag1 === 'padding') {
            location.reload()
        }
        flag1 = 'success'
        console.log('websocket success');
    }
    socket1.onmessage = (event) => {
    }
    socket1.onclose = () => {
        console.log('websocket close');
        flag1 = 'padding'
        if (flag1 === 'padding') {
            socket1.close()
            sto1 = setTimeout(() => {
                init()
            }, 2000)
        }
        else {
            location.reload()
            return clearTimeout(sto1)
        }
    }
    provide('socket1', socket1)
}
 
onMounted(() => {
    init()
    window.onbeforeunload = () => {
        socket.close();
        socket1.close();
    }
    init1()
    initAutofit()
})

onUnmounted(() => {
    destroyAutofit()
})


</script>

<style lang="scss" >
/* ===== 全局基础样式 + 自适应兜底 ===== */
html,
body {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    overflow: hidden;
}

/* body 继承 rem 基准 —— 让未写死 px 的元素跟随 html font-size */
body {
    font-size: 1rem;
}

/* Element Plus 字体变量 —— 跟随 html font-size 精确变化 */
:root {
    --el-font-size-base: 1rem;
    --el-font-size-small: 0.875rem;
    --el-font-size-extra-small: 0.75rem;
    --el-font-size-large: 1.25rem;
}

/* #app 固定为设计稿宽度 (1920px)，由 autofit.js 用 CSS zoom 等比缩放 */
#app {
    width: 1920px;
    height: 100%;
    transform-origin: top left;
}

/* 让 Element Plus 在缩放时保持文字清晰 */
html {
    -webkit-font-smoothing: antialiased;
}

.el-text {
    cursor: pointer;
}

.el-tag {
    cursor: pointer;
}

.el-table {
    width: 98% !important;
    margin: 10px auto;
}

.table1 {
    .custom-header {
        background-color: #cadef777 !important;
    }

    // 表体
    .el-table__inner-wrapper {
        background-color: transparent !important;
        color: #000;
        border-bottom: 0;
    }

    //    表头字体颜色
    .el-table__header-wrapper .cell {
        box-sizing: border-box;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: normal;
        color: rgb(21, 32, 134);
    }
}

.table2 {
    background-color: rgba($color: #f1e1e1, $alpha: .4) !important;
    border-radius: 20px;
    box-shadow: 0 10px 20px 10px #e2e2e2;
    text-align: center !important;

    // 表体
    .el-table__inner-wrapper {
        background-color: transparent !important;
        color: #000;
        border-bottom: 0;
    }

    // 表头圆角及边框
    .el-table__header-wrapper {
        border-radius: 20px;
        border: 1px solid yellowgreen;
        box-shadow: 0 5px 5px 5px #e2e2e2;
    }

    // 表头字体颜色
    .el-table__header-wrapper .cell {
        box-sizing: border-box;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: normal;
        color: rgb(33, 151, 33);
    }

    .el-table__body-wrapper {
        border-radius: 20px;
        margin-top: 10px;
    }
}

.option1 {
    width: 98% !important;
    margin: 10px auto 15px !important;
    background-color: rgba(255, 255, 255) !important;
    padding: 10px 15px !important;
    box-sizing: border-box;

}

.option2 {
    width: 98% !important;
    margin: 10px auto 0px !important;
    background-color: rgba(255, 255, 255) !important;
    border-radius: 10px !important;
    box-shadow: 0 0 10px 5px #e2e2e2;
    padding: 10px 15px !important;
    box-sizing: border-box;

}


:deep(.custom_select) {
    // width: 400px;
    height: 30px;

    :deep(.el-input__wrapper) {
        height: 32px;

    }

}


.el-input-number__decrease,
.el-input-number__increase {
    display: none !important;
}

.el-input__wrapper {
    padding: 0 15px !important;
}



/* 修改垂直滚动条 */
::-webkit-scrollbar {
    width: 8px;
    /* 修改宽度 */
}

::-webkit-scrollbar {
    height: 8px;
    /* 修改宽度 */
}

/* 修改滚动条轨道背景色 */
::-webkit-scrollbar-track {
    background-color: transparent;
}

/* 修改滚动条滑块颜色 */
::-webkit-scrollbar-thumb {
    background-color: #c7c7c7;
}

/* 修改滚动条滑块悬停时的颜色 */
::-webkit-scrollbar-thumb:hover {
    background-color: rgb(114, 114, 114);
}

/* 修改滚动条滑块的圆角 */
::-webkit-scrollbar-thumb {
    border-radius: 5px;
}</style>
